import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';
import { NoDataItem } from '~/modules/common/components';
import ClientInfoDetail from './ClientInfoDetail';
import ClientInfoInvoiceCurrency from './ClientInfoInvoiceCurrency';

const taxProfileLabel = <FormattedMessage id="client.taxProfile" />;
const paymentTermLabel = <FormattedMessage id="client.paymentTerm" />;
const invoiceTemplateLabel = <FormattedMessage id="client.invoiceTemplate" />;

export const noInvoiceTemplate = (
  <NoDataItem>
    <FormattedMessage id="client.noInvoiceTemplate" />
  </NoDataItem>
);
export const noTaxProfile = (
  <NoDataItem>
    <FormattedMessage id="client.noTaxProfile" />
  </NoDataItem>
);
export const ClientInfoBillingSection = ({ details, featureFlags }) => {
  const invoiceCurrency = get(details, 'invoiceCurrency', {});
  const invoicePaymentTerm = get(details, 'defaultInvoicePaymentTerm');
  const { invoiceTemplate, taxProfile } = details;
  const invoiceDisplayText = invoiceTemplate?.displayText || noInvoiceTemplate;
  const taxProfileDisplayText = taxProfile?.displayText || noTaxProfile;
  const detail = invoicePaymentTerm.toString();

  return (
    <>
      <ClientInfoInvoiceCurrency invoiceCurrency={invoiceCurrency} />
      <ClientInfoDetail label={paymentTermLabel} detail={detail} />
      <ClientInfoDetail
        label={taxProfileLabel}
        detail={taxProfileDisplayText}
      />
      <ClientInfoDetail
        label={invoiceTemplateLabel}
        detail={invoiceDisplayText}
      />
    </>
  );
};

ClientInfoBillingSection.propTypes = {
  details: PropTypes.object,
  featureFlags: PropTypes.object
};

export default ClientInfoBillingSection;
